<template>
  <div class="report-comm">
    <div id="page-trackReport ">
      <div class="head-tab--nav">
        <div class="head-nav h-3">
          <span class="c-normal">{{ Title }}</span>
          <div class="pull-right">
            <el-button type="primary" @click="daochu">{{
              $t("Common.btn_export")
            }}</el-button>
          </div>
        </div>
      </div>
      <div class="trackReport -container">
        <div class="content">
          <div class="flex-al mb10 mr20">
            <div class="select-box flex-al">
              <el-select
                v-model="selectForm.coursetype_id"
                clearable
                filterable
                :placeholder="
                  $t('views.Analysisreport.admTrackReport.51yzwntm4j40')
                "
                @change="selectSearch"
              >
                <el-option
                  v-for="(item, index) in coursetypeList"
                  :key="index"
                  :label="
                    `${item.coursetype_cnname}(${item.coursetype_branch})`
                  "
                  :value="item.coursetype_id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="content-nav--head text-1">
            <div class="c-n--head_lf">
              <div class="time head-right">
                <el-date-picker
                  v-model="selectForm.month"
                  type="month"
                  :placeholder="$t('Report.placeholder4')"
                  value-format="yyyy-MM"
                  @change="selectSearch()"
                  style="width: 150px;"
                ></el-date-picker>
              </div>
              <el-input clearable placeholder="请输入姓名、手机号、报名课程" class="input-cont input-keword" @change="handleSelectKeyword()" v-model="selectForm.keyword"  clearable></el-input>
              <el-button type="primary" class="btn-inquire"  @click="handleSelectKeyword()">查询</el-button>
            </div>
          </div>-->
          <reportTbale
            :list="tableList.list"
            :options="tableList.options"
            :columns="tableList.columns"
            :issetting="true"
            :operates="tableList.operates"
            :tableOperate="tableList.tableOperate"
            @toggleEditableColumn="toggleEditableColumn"
          ></reportTbale>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dataNumber"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 编辑列 -->
    <el-dialog
      :title="$t('Common.editTableTitle')"
      class="setting-column"
      :visible.sync="settingVisible"
      width="450px"
      :before-close="handleClose"
    >
      <el-transfer
        :titles="$t('Common.editTableTitles')"
        v-model="oprateColumn"
        :data="data"
      ></el-transfer>
      <div class="oprate">
        <el-button type="primary" size="small" @click="handClickOprate()">{{
          $t("Common.btn_confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import reportTbale from "../../components/Table/reportTbale";
import storeAnalysisreport from "../../views/Analysisreport/analysisreport.js";
export default {
  name: "reportTable",
  components: {
    reportTbale,
  },
  props: ["Title", "wayString", "placehold"],
  data() {
    return {
      wayProp: "", //方法名
      // 表格筛选
      selectForm: {
        month: "",
        keyword: "",
        coursetype_id: "",
      },
      coursetypeList: [],

      tableList: {
        operates: {
          width: 200,
          label: this.$t("Common.operatesLabel"),
          align: "center",
          isfixed: true,
          fixed: "right",
          list: [],
        },
        tableOperate: {
          label: "11",
          operate: true,
          align: "center",
          fixed: "right",
        },
        options: {
          stripe: false,
          tableHeight: Number,
          mutiSelect: false, // 是否支持列表项选中功能
          highlightCurrentRow: true, // 是否支持当前行高亮显示
        },
        columns: [],
        columnWidth: [],
        list: [],
      },
      // 分页
      dataNumber: 0, //数据总数
      pageNum: 1,
      pageSize: 10,
      currentPage: 1,
      sizeArray: [10, 20, 30, 40],
      // 编辑列
      settingVisible: false,
      data: [],
      oprateColumn: [1, 4], //编辑列
      showColumn: [],
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  created() {
    (() => {})(this.wayString, "this.wayString");
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;

    this.tableList.options.tableHeight = this.$Common.getTableHeight(205);
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    this.selectForm.month = year + "-" + month;
    this.courseTypeApi();

    this.Analysisreport(0);
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    //下拉列表->获取班组列表--zjb
    courseTypeApi() {
      storeAnalysisreport.courseTypeApi({}).then((res) => {
        if (res.data.code === 200) {
          this.coursetypeList = res.data.data.list;
        } else {
          this.coursetypeList = [];
        }
      });
    },
    //分析报表列表及导出报表
    Analysisreport(is_export) {
      storeAnalysisreport[this.wayString]({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        p: this.currentPage,
        num: this.pageSize,
        is_count: "1", //是否需要总数
        coursetype_id: this.selectForm.coursetype_id,

        //数据筛选
        month: this.selectForm.month,
        is_export: is_export,
      }).then((res) => {
        var Columns = res.data.data.field;
        this.allColumns = res.data.data.field; //刚开始 存储所有的后台传过来的数据
        var fieldColumns = res.data.data.field; //编辑之后，需要显示的数据
        //存储要显示的['show'+this.wayString]
        if (JSON.parse(localStorage.getItem("reportColumns"))) {
          let obj = JSON.parse(localStorage.getItem("reportColumns"));
          (() => {})(this.wayString);
          let valueName = "all" + this.wayString;
          (() => {})(valueName, "属性名属性名");
          obj[valueName] = this.allColumns; //  allstureport
          this.$Tool.setStorage("reportColumns", obj);
          (() => {})("有数据", obj);
        } else {
          //第一次 无数据
          (() => {})("无数据");
          let obj1 = {};
          let valueName = "all" + this.wayString;
          obj1[valueName] = this.allColumns; //  allstureport
          this.$Tool.setStorage("reportColumns", obj1);
        }
        if (
          JSON.parse(localStorage.getItem("reportColumns"))[
            "show" + this.wayString
          ]
        ) {
          this.showColumn = JSON.parse(localStorage.getItem("reportColumns"))[
            "show" + this.wayString
          ];
          Columns = this.showColumn;
          fieldColumns = this.showColumn;
        }

        // 自定义编辑列
        var settingOprateData = this.$Common.settingOprateData(fieldColumns);
        this.data = settingOprateData.data;
        this.oprateColumn = settingOprateData.oprateColumn;

        this.dataNumber = parseInt(res.data.data.allnum);
        this.tableList.columns = Columns;
        // this.tableList.columns[1].ismethod = true;
        if (res.data.code === 200) {
          this.tableList.list = res.data.data.list;
        } else {
          this.tableList.options.errortip = res.data.msg;
          this.tableList.list = [];
        }
      });
    },
    // 数据检索
    selectSearch() {
      this.currentPage = 1;
      (() => {})(this.selectForm);
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 自定义编辑列
    handClickOprate() {
      let allcom = JSON.parse(localStorage.getItem("reportColumns"));
      // (() => {})(this.wayString)
      // (() => {})(allcom)
      let allnum = allcom["all" + this.wayString];
      allnum.forEach((item, index) => {
        allnum[parseInt(index)].show = "1";
      });
      this.oprateColumn.forEach((item, index) => {
        (() => {})(allnum[parseInt(item)]);
        allnum[parseInt(item)].show = "0";
      });
      this.showColumns = allnum;
      let obj = this.$Tool.getStorage("reportColumns");
      obj["show" + this.wayString] = this.showColumns;
      this.$Tool.setStorage("reportColumns", obj);

      this.settingVisible = false;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 显示 列切换
    toggleEditableColumn() {
      (() => {})("显示 列切换");
      this.settingVisible = !this.settingVisible;
    },
    handleClose(done) {
      done();
    },
    // 分页
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pageSize = val;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.Analysisreport(0); //分析报表列表及导出报表
    },
    // 导出操作
    daochu() {
      let url = storeAnalysisreport[this.wayString + "1"]();
      var is_export = 1;
      let language_type = this.$Tool.getStorage("language")
        ? this.$Tool.getStorage("language")
        : "zh";
      (() => {})(this.tableList.list.length);
      if (this.tableList.list.length > 0) {
        window.open(
          this.$buildExportUrl(`${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&is_export=${is_export}&month=${this.selectForm.month}&coursetype_id=${this.selectForm.coursetype_id}&language_type=${language_type}`),
          "_blank"
        );
      } else {
        this.$message.error(this.$t("Report.errorMessage1"));
      }
    },
    getSTime(val) {
      this.Analysisreport(0);
    },
  },
};
</script>

<style lang="less"></style>
